<template>
  <h4 class="font-medium leading-10 text-xl">Inhaltsverzeichnis</h4>
  <nav id="toc" class="h-full overflow-x-hidden p-2 overflow-y-scroll">
    <div v-for="code in Object.keys(availableSections)" :key="code" class="flex items-center">
      <TableOfContentsItem :item="code" :paragraph-num="orderedNumberedParagraphs.indexOf(code) + 1" />
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useLegalDocumentStore } from '@/questionnaire/stores/legalDocument'
import TableOfContentsItem from './TableOfContentsItem.vue'
import { useLegalDocumentTemplateStore } from '@/questionnaire/stores/legalDocumentTemplate'
import { storeToRefs } from 'pinia'

const legalDocumentStore = useLegalDocumentStore()
const legalDocumentTemplateStore = useLegalDocumentTemplateStore()

const { sections: availableSections } = storeToRefs(legalDocumentTemplateStore)
const orderedNumberedParagraphs = ref(<string[]>[])

watch(legalDocumentStore, () => {
  orderedNumberedParagraphs.value = <string[]>Object.values(legalDocumentTemplateStore.sections)
    .filter(sec => sec.numbered_paragraph && legalDocumentStore.sections.includes(sec.code))
    .map(sec => sec.code)
})
</script>
